module.exports = Object.freeze({
    FIRST_NAME_REQUIRED: 'First name is required.',
    FIRST_NAME_LENGTH: 'First name must be between 2 and 15 characters.',
    LAST_NAME_REQUIRED: 'Last name is required.',
    LAST_NAME_LENGTH: 'Last name must be between 2 and 15 characters.',
    ADMIN_USER_NAME_REQUIRED: 'Admin username is required.',
    USERNAME_LENGTH: 'Username must be between 5 and 15 characters.',
    EMPLOYEE_ID_REQUIRED: 'Employee ID is required.',
    EMPLOYEE_ID_LENGTH: 'Employee ID must be between 10 and 15 characters.',
    IP_REQUIRED: 'IP address is required.',
    VALID_IP_REQUIRED: 'Please enter a valid IP address (e.g., 192.168.1.1).',
    IP_REGEX: /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/,
    EMAIL_REQUIRED: 'Email address is required.',
    ERROR_EMAIL_VALID: 'Please enter a valid email address (e.g., example@domain.com).',
    EMAIL_REGEX: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    PASSWORD_REQUIRED: 'Password is required.',
    STRONG_PASSWORD_ERROR: 'Password must contain at least 8 characters, including an uppercase letter, a lowercase letter, a number, and a special character from @$!%*?&. Only letters, numbers, and these special characters are allowed.',
    PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    CONFIRM_PASSWORD_REQUIRED: 'Please confirm your password.',
    CONFIRM_PASSWORD_NOT_MATCH: 'Passwords do not match.',
    OTP_REQUIRED: 'Verification code is required.',
    OTP_REGEX: /^\d{6}$/,
    OTP_INCORRECT_ERROR: 'Please enter a valid 6-digit verification code.',
    // International format only; does not verify country allocation or mobile line type.
    MOBILE_REGEX: /^\+[1-9]\d{1,14}(?![\s\S])/,
    MOBILE_MESSAGE: 'Please enter your mobile number with + and the country code (e.g., +919876543210). Use no more than 15 digits, without spaces or hyphens.',
    USER_NAME_EXISTENCE: 'This username is already taken. Please choose a different one.',
    FAILED_MSG: "We could not process your request. Please try again.",
    SERVER_ERROR: "A server error occurred. Please try again later.",
    EMAIL_ALREADY_EXISTS: "This email address is already registered. Please use a different email address.",
    EMPLOYEE_ID_ALREADY_EXISTS: "This employee ID is already in use. Please enter a different employee ID.",
    VALID_NOTE_REQUIRED: "Please enter a reason for this action.",

});
